// extracted by mini-css-extract-plugin
module.exports = {"CheckboxArea":"Checkbox_CheckboxArea__sQBEP","Checkbox":"Checkbox_Checkbox__10ASF","Icon":"Checkbox_Icon__WOmvT","Children":"Checkbox_Children__QpDzU"};